export const omitWithCap = (num: number, cap = 99) => (num > cap ? `${cap}+` : `${num}`);

export const isNumericString = (str: string) => str !== '' && !Number.isNaN(Number(str));
